<template>
  <div id="marketplace-container">
    <div>
      <h1>Marketplace</h1>
      <!--     <dialog id="filters-modal">
        <svg @click="closeModal('filters-modal'); assignFilteringValues()" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <h2>Filters</h2>
        <table class="input-table card-band-styling">
          <tbody>
            <tr>
              <th colspan="2">Search</th>
            </tr>
            <tr>
              <td>Free Search:</td>
              <td>
                <input type="text" v-model="inputObject.search_query">
              </td>
            </tr>
            <tr>
              <th colspan="2">Filtering</th>
            </tr>
            <tr class="range-row">
              <td>Age Range:</td>
              <td>
                <select v-model="inputObject.startAgeValue" id="startAge" class="ageGroup" @change="changeStartAgeRange">
                  <option value="All">All</option>
                  <option v-for="(item,index) in maxAgeRange" :key="index" :value="item">{{ item }}</option>
                </select>
                to
                <select v-model="inputObject.endAgeValue" id="endAge" class="ageGroup" @change="changeStartAgeRange">
                  <option value="All">All</option>
                  <option v-for="(item,index) in (inputObject.startAgeValue == 'All' ? maxAgeRange : maxAgeRange-parseInt(inputObject.startAgeValue)+1)" :key="index" :value="inputObject.startAgeValue == 'All' ? item : parseInt(inputObject.startAgeValue)+index">{{ inputObject.startAgeValue == 'All' ? item : parseInt(inputObject.startAgeValue)+index }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>Classification:</td>
              <td>
                <select v-model="inputObject.classification">
                  <option value="All">All</option>
                  <option value="Assessment/Test">Assessment/Test</option>
                  <option value="Screening/Mini-Test">Screening/Mini-Test</option>
                  <option value="Intervention/Training/Lesson">Intervention/Training/Lesson</option>
                </select>
              </td>
            </tr>
            <tr class="range-row">
              <td>Period:</td>
              <td>
                <input type="date" id="startDate" @change="changeStartDate" v-model="inputObject.periodStart">
                to
                <input type="date" id="endDate" @change="changeStartDate" v-model="inputObject.periodEnd">
                <span class="tooltip-searchDate">
                  <font-awesome-icon :icon="['fas', 'circle-info']" style="vertical-align: middle; margin-left: 5px" />
                  <span class="tooltiptext-searchDate">
                    <table class="tooltip-table">
                      <tbody>
                        <tr>
                          <td>mm/dd/yyyy to mm/dd/yyyy:</td>
                          <td>All Dates</td>
                        </tr>
                        <tr>
                          <td>06/12/2015 to mm/dd/yyyy:</td>
                          <td>06/12/2015 to Present</td>
                        </tr>
                        <tr>
                          <td>mm/dd/yyyy to 06/12/2015:</td>
                          <td>Past to 06/12/2015</td>
                        </tr>
                      </tbody>
                    </table>
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: center;">
                <button @click="newFilters">Search Filtering</button>
              </td>
            </tr>
          </tbody>
        </table>
      </dialog>
      <dialog id="pricing-modal">
        <div v-if="pricingModalObject">
          <svg @click="closeModal('pricing-modal'); assignFilteringValues()" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
          <div class="pricing-status">
            Sale Status: 
            <span
              :style="{ color: pricingModalObject.on_sale ? '#79BA81' : 'red' }"
            >
            {{ pricingModalObject.on_sale ? 'For Sale' : 'Not For Sale' }}</span>
          </div>
          <div class="pricing-flexbox">
            <div>
              <h4>Unit Pricing</h4>
              <div class="pricing-numbers"><span>{{ pricingModalObject.single_unit_pricing }}</span> / Unit</div>
              <div class="pricing-description">
                Flexible and cost-effective <div>Only pay for what you will use, with no commitments</div> 
              </div>
              <div class="feature-grid">
                <svg xmlns="http://www.w3.org/2000/svg" class="checkbox" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                <div>Comprehensive Reports</div>
                <svg xmlns="http://www.w3.org/2000/svg" class="checkbox" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                <div>All Interactions</div>
                <svg class="x-box" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
                <div>Will not Expire for 5 Years</div>
              </div>
            </div>
            <div>
              <h4>Monthly Pricing</h4>
              <div class="pricing-numbers"><span>{{ pricingModalObject.monthly_subscription_pricing }}</span> / Month</div>
              <div class="pricing-description">
                Unlimited access <div>Freedom to use as much as you need!</div>
              </div>
              <div class="feature-grid">
                <svg xmlns="http://www.w3.org/2000/svg" class="checkbox" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                <div>Comprehensive Reports</div>
                <svg xmlns="http://www.w3.org/2000/svg" class="checkbox" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                <div>All Interactions</div>
                <svg xmlns="http://www.w3.org/2000/svg" class="checkbox" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                <div>Free Use</div>
              </div>
            </div>
          </div>
        </div>
      </dialog>
      <div class="function-buttons">
        <button style="margin-right: 5px;" @click="openModal('filters-modal')">Filters ({{ Object.keys(params).length }})</button>
      </div> -->
      <div id="marketplace-app-format">
        <article v-for="(app, index) in applicationList" class="application-container" :key="index">
          <router-link :to="`/application/${app.application_id}`">
            <img v-if="app.image" :src="`${reverseProxy}/api/${app.image}`" alt="Picture N/A" loading="lazy"/>
            <h4>{{ app.title }}</h4>
            <div v-if="app.is_free">
              Free
            </div>
            <div v-else>
              <div class="unit-pricing">{{  `${getCurrencySymbol(app.currency_code)} ${app.single_unit_pricing}/unit` }}</div>
              <div class="monthly-pricing">{{ `${getCurrencySymbol(app.currency_code)} ${app.monthly_subscription_pricing}/month subscription` }}</div>
            </div>
          </router-link>
        </article>
      </div>
    </div>
  </div>
</template>

<script> 
  import instance from '../axios.js'; 

  export default {
    data() {
      return {
        reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
        applicationList: null,
        categorization: null,
        maxAgeRange: 100,
        pricingModalObject: null,
        inputObject: {
          search_query: '',
          startAgeValue: 'All',
          endAgeValue: 'All',
          classification: 'All',
          area: 'All',
          type: 'All',
          category: 'All',
          sub_category: 'All',
          periodStart: '',
          periodEnd: ''
        },
      }
    },
    async created() {
      try {
        this.assignFilteringValues();
        let response = await instance.get('/api/appAdmin/searchfilter', {
          params: {
            ...this.params,
            published: true
          }
        });
        this.applicationList = response.data;
      } catch (e) {
        console.error(e);
      }
    },
    methods: {
      async showPreviewModal(app) {
        this.$router.push({
          path: `/testAppMenu/${app.application_id}`
        })
      },
      openModal(id) {
        document.getElementById(id).showModal();
      },
      closeModal(id) {
        document.getElementById(id).close();
      },
      routeAppPage(appID) {
        this.$router.push(`/application/${appID}`);
      },
      assignFilteringValues() {
        this.params = this.getQueryParams();
        //parse query so search/filter can be used again with auto filled current data
        for (let key in this.params) {
          if (Object.hasOwnProperty.call(this.inputObject, key)) {
            this.inputObject[key] = this.params[key];
          }
          else if (key == 'age_group') {
            let ages = this.params['age_group'].split(',');
            this.inputObject.startAgeValue = ages[0];
            this.inputObject.endAgeValue = ages[1];
          }
          else if (key == 'created') {
            let dates = this.params['created'].split(',');
            this.inputObject.periodStart = dates[0] == 'All' ? '' : dates[0];
            this.inputObject.periodEnd = dates[1] == 'All' ? '' : dates[1];
          }
        }
      },
      changeStartDate() {
        let from = document.getElementById('startDate');
        let to = document.getElementById('endDate');
        if (from.value >= to.value && to.value !== '') {
          let temp = new Date(from.value);
          temp.setDate(temp.getDate());
          to.valueAsDate = temp;
        }
        to.min = from.value;
      },
      changeStartAgeRange() {
        let from = document.getElementById('startAge');
        let to = document.getElementById('endAge');
        if (from.value != 'All' && to.value != 'All') {
          if (parseInt(from.value) > parseInt(to.value)) {
            this.inputObject.endAgeValue = this.maxAgeRange;
          }
        }
      },
      getQueryParams() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const params = {};
        for (const [key, value] of urlParams.entries()) {
          params[key] = value;
        }
        return params;
      },
      async newFilters() {
        try {
          let ageRangeResult = '';
          ageRangeResult += this.inputObject.startAgeValue;
          ageRangeResult += ',';
          ageRangeResult += this.inputObject.endAgeValue;

          let periodRangeResult = '';
          periodRangeResult += this.inputObject.periodStart == '' ? 'All' : this.inputObject.periodStart;
          periodRangeResult += ',';
          periodRangeResult += this.inputObject.periodEnd == '' ? 'All' : this.inputObject.periodEnd;

          const currentRoute = this.$route;
          const targetQuery = {
            ...(this.inputObject.search_query == '' ? {} : {search_query: this.inputObject.search_query}),
            ...(ageRangeResult == 'All,All' ? {} : {age_group: ageRangeResult}),
            ...(this.inputObject.classification == 'All' ? {} : {classification: this.inputObject.classification}),
            ...(this.inputObject.area == 'All' ? {} : {area: this.inputObject.area}),
            ...(this.inputObject.type == 'All' ? {} : {type: this.inputObject.type}),
            ...(this.inputObject.category == 'All' ? {} : {category: this.inputObject.category}),
            ...(this.inputObject.sub_category == 'All' ? {} : {sub_category: this.inputObject.sub_category}),
            ...(periodRangeResult == 'All,All' ? {} : {created: periodRangeResult})
          };
          const currentKeys = Object.keys(currentRoute.query);
          const targetKeys = Object.keys(targetQuery);
          const isSameKeys = currentKeys.length === targetKeys.length && currentKeys.every(key => targetKeys.includes(key));
          const isDifferentQuery = !isSameKeys || !currentKeys.every(key =>
            currentRoute.query[key] === targetQuery[key]
          );

          if (isDifferentQuery) {
            this.$router.replace({ query: targetQuery });
            this.assignFilteringValues();
            let response = await instance.get('/api/appAdmin/searchfilter', {
              params: {
                ...this.params,
                published: true
              }
            });
            this.applicationList = response.data;
          }

        } catch (e) {
          console.error(e);
        }
      },
      assignPricingModalObject(obj) {
        this.pricingModalObject = obj;
      },
      getCurrencySymbol(currencyCode) {
        const currencyMap = {
            USD: "$",
            EUR: "€",
            GBP: "£",
            JPY: "¥",
            CNY: "¥",
            RUB: "₽"
        };
        return currencyMap[currencyCode] || "";
      },
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  #marketplace-container {
    font-family: 'Roboto', sans-serif;
    position: relative;

    > div {
      padding: 1rem;
    }
  }

  .function-buttons {
    display: inline-block;
    padding: .25rem;
    position: sticky;
    border-radius: 50rem;
    top: globalSharedVariables.$navbar-height;
    z-index: 20;

    button {
      width: 200px;
      font-size: 1rem;
    }
  }

  .cards-format {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;

    .app-card {
      $inner_padding: 16px;

      $card_width: 400px;
      $card_height: 300px;
      $inner_card_height: $card_height - (2 * $inner_padding);
      $inner_card_width: $card_width - (2 * $inner_padding);

      padding: $inner_padding;
      width: $card_width;
      height: $card_height;
      margin: 1rem;
      
      > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .icon-row {
        display: flex;
        justify-content: space-between;

        svg {
          height: 1rem;
        }
      }

      .app-card-grid {
        display: grid;
        grid-template-rows: 31px 17px auto;
      }

      .app-card-title {
        font-size: 1.3rem;
        font-weight: 700;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .app-card-subtitle {
        font-size: .7rem;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .app-card-image {
        img {
          border-radius: 10px;
          width: $inner_card_width;
          height: 200px;
          object-fit: cover;
        }
      }

      .tooltip-icon {
        position: relative;
        display: inline-block;
        cursor: pointer;

        .tooltiptext-icon {
          display: none;
          width: fit-content;
          background-color: lightgrey;
          text-align: center;
          border-radius: 6px;
          padding: 5px;
          position: absolute;
          z-index: 1;
          bottom: 120%;
          left: 50%;
          transform: translateX(-50%);
          font-size: .8rem;
          font-weight: 400;
          transition: opacity 0s linear .5s;
          opacity: 0;

          &::after {
            content: "";
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: lightgrey transparent transparent transparent;
          }
        }

        &:hover {
          .tooltiptext-icon {
            display: block;
            opacity: 1;
          }
        }
      }
    }
  }

  #filters-modal {
    .input-table {
      border-spacing: 0;
      border-collapse: separate;
      
      tbody {
        margin-top: 10px;
      }

      tr > td:first-child {
        text-align: right;
      }

      input[type="date"], .ageGroup {
        width: fit-content;
        padding: 0 1rem;
        cursor: pointer;
      }

      td, th {
        padding: 5px;
      }

      th {
        text-align: center;
        width: 100%;
      }
    }

    .tooltip-searchDate {
      position: relative;
      display: inline-block;

      .tooltiptext-searchDate {
        display: none;
        width: fit-content;
        background-color: white;
        text-align: center;
        border-radius: 6px;
        padding: 5px;
        position: absolute;
        z-index: 1;
        bottom: 150%;
        left: 50%;
        transform: translateX(-100%);
        font-size: .8rem;
        font-weight: 400;
      }

      &:hover .tooltiptext-searchDate {
        display: block;
      }

      .tooltip-table {
        td {
          border: solid black 1px;
        }
      }
    }
  }

  #pricing-modal {
    .pricing-status {
      font-size: 1.2em;
    }

    .pricing-flexbox {
      display: grid;
      grid-template-columns: auto auto;
      column-gap: 1rem;

      > div {
        display: grid;
        grid-template-rows: auto auto 100Px auto;
        padding: 1rem;
        border-radius: 5px;
        box-shadow: 0 0 5px 0 grey;
        width: 300px;

        > * {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }

        h4 {
          background: linear-gradient(to top, globalSharedVariables.$orange-2, globalSharedVariables.$orange-1);
          padding: .5rem;
          border-radius: 5px;
          width: 100%;
          text-align: center;
        }

        .pricing-numbers {
          font-size: .8rem;

          span {
            font-size: 2rem;
          }
        }

        .pricing-description {
          text-align: center;
        }

        .feature-grid {
          display: grid;
          grid-template-columns: auto auto;
          column-gap: 10px;

          > div {
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }

          .checkbox {
            fill: #79BA81;
            height: 1rem;
          }

          .x-box {
            fill: red;
            height: 1rem;
          }
        }
      }
    }
  }

  #marketplace-app-format {
    display: flex;
    column-gap: 5px;
    row-gap: 2rem;
    flex-wrap: wrap;

    h4 {
      margin: 0;
    }

    .application-container {
      img {
        width: 420px;
        height: 285px;
        border-radius: 10px;
      }

      .monthly-pricing {
        color: #636363;
        font-size: .8rem;
      }

      a {
        text-decoration: none;
        color: black;
        display: block;
      }
    }
  }

</style>